import type { FC } from 'react'

import { ArrowLeftOutline16 } from '@sok/design-system'
import { NextLink } from 'components/NextLink'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const _StoresPageLink: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()

  return (
    <NextLink className={className} data-test-id="all-stores-link" href="/myymalat">
      <ArrowLeftOutline16 />
      <span>{t`Stores`}</span>
    </NextLink>
  )
}

_StoresPageLink.displayName = 'StoresPageLink'

export const StoresPageLink = styled(_StoresPageLink)(({ theme }) => ({
  ...theme.variants.body1.regular,
  alignItems: 'center',
  display: 'inline-flex',

  span: {
    marginLeft: theme.spacings.xxxSmall,
  },
}))
